// Module
var code = "<div class=\"row\"> <div class=\"col-md-12\"> <remote-paged-grid-layout title-label-code=\"'booths'\" new-entity-label-code=\"'booth.new'\" columns=\"columns\" find-page=\"findPage\" sort-info=\"sortInfo\" export-to-csv=\"exportToCsv\"></remote-paged-grid-layout> </div> </div> ";
// Exports
export default code;